import { render, staticRenderFns } from "./ListaProdutos.vue?vue&type=template&id=2b0c371b&scoped=true"
import script from "./ListaProdutos.vue?vue&type=script&lang=js"
export * from "./ListaProdutos.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-modal.css?vue&type=style&index=0&id=2b0c371b&prod&scoped=true&lang=css&external"
import style1 from "./ListaProdutos.vue?vue&type=style&index=1&id=2b0c371b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c371b",
  null
  
)

export default component.exports